/**
 * LinkedIn Ads Adapter
 * 
 * Adapts event data into LinkedIn Insight Tag format.
 * LinkedIn uses conversion IDs configured in the LinkedIn Ads platform.
 * 
 * @since 1.51.0
 */

(function (wpm, $, undefined) {

	class LinkedInAdapter {
		
		/**
		 * Adapt event data to LinkedIn Insight Tag format
		 * 
		 * @param {object} eventData - Event-specific data (product, order, etc.)
		 * @param {string} eventName - Standardized event name
		 * @param {object} context - Event context (user, page, etc.)
		 * @returns {object|null} Adapted data for LinkedIn or null if pixel not loaded
		 */
		adapt(eventData, eventName, context) {
			
			// Check if LinkedIn pixel is loaded
			if (!wpmDataLayer?.pixels?.linkedin?.loaded) {
				return null;
			}
			
			const eventMap = {
				'search': () => this.adaptSearch(eventData),
				'view_item': () => this.adaptViewContent(eventData),
				'add_to_cart': () => this.adaptAddToCart(eventData),
				'begin_checkout': () => this.adaptStartCheckout(eventData),
				'purchase': () => this.adaptPurchase(eventData),
				'add_to_wishlist': () => this.adaptAddToList(eventData),
			};
			
			if (!eventMap[eventName]) {
				return null;
			}
			
			return eventMap[eventName]();
		}
		
		/**
		 * Get conversion ID for a specific event
		 */
		getConversionId(eventType) {
			return wpmDataLayer?.pixels?.linkedin?.conversion_ids?.[eventType] || null;
		}
		
		/**
		 * Adapt search event
		 */
		adaptSearch(eventData) {
			const conversion_id = this.getConversionId('search');
			if (!conversion_id) return null;
			
			return {
				conversion_id: conversion_id,
			};
		}
		
		/**
		 * Adapt view_content event
		 */
		adaptViewContent(eventData) {
			const conversion_id = this.getConversionId('view_content');
			if (!conversion_id) return null;
			
			return {
				conversion_id: conversion_id,
			};
		}
		
		/**
		 * Adapt add_to_cart event
		 */
		adaptAddToCart(eventData) {
			const conversion_id = this.getConversionId('add_to_cart');
			if (!conversion_id) return null;
			
			return {
				conversion_id: conversion_id,
			};
		}
		
		/**
		 * Adapt start_checkout event
		 */
		adaptStartCheckout(eventData) {
			const conversion_id = this.getConversionId('start_checkout');
			if (!conversion_id) return null;
			
			return {
				conversion_id: conversion_id,
			};
		}
		
		/**
		 * Adapt purchase event
		 */
		adaptPurchase(eventData) {
			const conversion_id = this.getConversionId('purchase');
			if (!conversion_id) return null;
			
			return {
				conversion_id: conversion_id,
			};
		}
		
		/**
		 * Adapt add_to_wishlist event
		 */
		adaptAddToList(eventData) {
			const conversion_id = this.getConversionId('add_to_list');
			if (!conversion_id) return null;
			
			return {
				conversion_id: conversion_id,
			};
		}
	}
	
	// Register the adapter
	wpm.registerAdapter('linkedin', new LinkedInAdapter(), {
		supportsS2S: false,
		supportsEventDeduplication: false,
		isActive: () => wpmDataLayer?.pixels?.linkedin?.partner_id ? true : false
	});
	
}(window.wpm = window.wpm || {}, jQuery));
